// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"BtZWo__dropdownMenu"};